import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBxArea = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M3 5v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2Zm16.002 14H5V5h14l.002 14Z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M15 12h2V7h-5v2h3v3Zm-3 3H9v-3H7v5h5v-2Z"
	})]
});
export default SvgBxArea;
